/**
 * Labstep
 *
 * @module components/File/Action/Upload
 * @desc Button to upload files to comment
 */

import GuardGroupCreate from 'labstep-web/components/Guard/GroupCreate';
import { FileUploadContainer } from 'labstep-web/containers/File/Upload';
import { Dropzone } from 'labstep-web/core/Dropzone';
import type { DropzoneProps } from 'labstep-web/core/Dropzone/types';
import type React from 'react';
import type {
  FileActionUploadProps,
  IFileActionUploadContainerProps,
} from './types';

export const FileActionUpload: React.FC<FileActionUploadProps> = ({
  disabled,
  uploading,
  entityId,
  entityType,
  field,
  orphanUuid,
  uploadFile,
  options = {},
  onDropAccepted: onDropAcceptedProp,
  ...rest
}) => {
  const isDisabled = disabled || uploading;
  const onDropAccepted: NonNullable<
    DropzoneProps['onDropAccepted']
  > = (files, event) => {
    onDropAcceptedProp?.(files, event);
    files.forEach((file) => {
      uploadFile(
        {
          file,
          entityId,
          entityType,
          orphanUuid,
          field,
        },
        options,
      );
    });
  };
  return (
    <Dropzone
      disabled={isDisabled}
      onDropAccepted={onDropAccepted}
      {...rest}
    />
  );
};

export const FileActionUploadContainer: React.FC<
  IFileActionUploadContainerProps
> = (props) => (
  <GuardGroupCreate>
    <FileUploadContainer
      entityType={props.entityType}
      entityId={props.entityId}
    >
      {(containerProps) => (
        <FileActionUpload {...props} {...containerProps} />
      )}
    </FileUploadContainer>
  </GuardGroupCreate>
);
